import React from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from "react-lazyload";

import Routing from '../../routing/Routing';
import { getAsset } from '../../../../../common/resources/assets/assets';
import { strings } from '../../../../../common/resources/locales/i18n';


//Components
import { AsyncImage } from '../../../components/AsyncImage';
import {ImageSvg} from "../../../components/ImageSvg";
import ModelsManager from "../../../../../common/modules/models/ModelsManager";

const VehiclesItems = (props) => {
  const {
    modelGroupDescription, productLineDescription, gearboxDescription, fuelDescription, colorDescription,
    finalPrice, finalPriceFormat, price, priceFormat, images, index, cuotaPriceFormat, id, power, addComparator,
    hasSpecialPrice, showModal, vehiclesIsComparator, tags
  } = props;

  return (
    <div key={index} className={!hasSpecialPrice ?"card card-product mb-3 " : "card card-product mb-3 border-secondary"} >
      <div className="card-body row d-flex align-items-center">

        <div className="card-product-tags">
          {tags && tags.map((item, key)=>{
            const backgroundHexColor = ModelsManager.getBackgroundHexColor(item)
            const tagText = ModelsManager.getTagText(item)
            const textHexColor = ModelsManager.getTextHexColor(item)

            return(
              <div key={key} className="card-tag bg-new small" style={{backgroundColor: backgroundHexColor, color: textHexColor }}>
                {tagText || ''}
              </div>
            )
          })}

        </div>


        <Link disable={vehiclesIsComparator} to={Routing.nowhere} onClick={() => vehiclesIsComparator ? () => {
        } : addComparator()} role="button" className={`card-product-comparador ${vehiclesIsComparator ? 'active' : ''}`}
              data-toggle="tooltip" data-placement="top">
          <ImageSvg src={getAsset('icComparator')}/>
        </Link>

        <div className="col-md-4">
          <div className="position-relative card-img">
            {renderImages(images, modelGroupDescription)}
          </div>
        </div>

        <div className="col-md-8 card-info">

          <h4 className="mb-3"><Link to={`${Routing.vehicleDetail}${id}`}
                                     className={!hasSpecialPrice ? "text-primary" : "text-secondary"}>{`${modelGroupDescription} ${productLineDescription}`}</Link>
          </h4>

          <div className="specs-grid mb-3">
            {power ? <div className="spec-item">
              <div className="spec-icon">
                <ImageSvg src={getAsset('icEngine')}/>

              </div>
              <div className="spec-text">{strings('vehicleDetails.powerValue', {value: power})}</div>
            </div> : <></>}

            {fuelDescription ? <div className="spec-item">
              <div className="spec-icon">
                <ImageSvg src={getAsset('icFlash')}/>

              </div>
              <div className="spec-text">{fuelDescription}</div>
            </div> : <></>}

            {gearboxDescription ? <div className="spec-item">
              <div className="spec-icon">
                <ImageSvg src={getAsset('icGearbox')}/>

              </div>
              <div className="spec-text">{gearboxDescription}</div>
            </div> : <></>}

            {colorDescription ? <div className="spec-item">
              <div className="spec-icon">
                <ImageSvg src={getAsset('icColorFilter')}/>

              </div>
              <div className="spec-text">{colorDescription}</div>
            </div> : <></>}
          </div>

          <div className="row d-flex align-items-lg-end mb-0">
            <div className="col-md-7">
              {/*<div className="badge badge-secondary">Quedan 12 unidades</div>*/}
              <div className="row mb-0 mt-2 text-center text-lg-start flex-column flex-md-row">
                <div className="col-md-7">
                  <div
                    className="mb-0 text-muted d-flex align-items-center justify-content-center align-items-lg-start flex-row flex-md-column"
                    style={{columnGap: '0.4rem'}}>
                    <small>{strings("models.from")}</small> <span
                    className="big-lg text-dark mb-0"><strong>{cuotaPriceFormat}</strong><small
                    className="small-lg">{strings("models.from2")}</small></span>
                  </div>
                </div>
                <div className="col-md-5">
                  <div
                    className="mb-0 text-muted d-flex align-items-center justify-content-center align-items-lg-start flex-row flex-md-column"
                    style={{columnGap: "0.4rem"}}>
                    <small>{strings("models.pvp")}</small> <span
                    className="big-lg text-secondary mb-0"><strong>{finalPriceFormat}</strong></span>
                    {finalPrice !== price ? <small className="text-muted small ml-1"><s>{priceFormat}</s></small> :
                      <span/>}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5 mt-3">
              <div className="action-buttons flex-md-column">
                <Link to={`${Routing.vehicleDetail}${id}`}
                      className={"btn btn-sm btn-secondary"}>{strings('button.moreInformation')}</Link>
                <Link to={Routing.nowhere} onClick={() => showModal()} className={"btn btn-sm btn-outline-secondary"}
                      data-toggle="modal" data-target="#modalReservation">
                  {strings('button.imInterested')}
                </Link>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  )
}

const renderImages = (images, modelGroupDescription) => {
  if (images && images.length !== 0) {
    return (
      <LazyLoad>
        <div className='item'>
          <AsyncImage
            source={images[0]}
            style='img-fluid'
            srcPlaceholder={getAsset('icPlaceholderModel')}
            alt={modelGroupDescription}
          />
        </div>
      </LazyLoad>
    )
  }
}

export default VehiclesItems
